(() => {
  const bar = document.getElementById('RSStickyProductCart');
  if (!bar || bar.dataset.initialized === 'true') return;
  bar.dataset.initialized = 'true';

  const main = document.getElementById('MainContent');
  const button = bar.querySelector('[data-sticky-button]');
  const price = bar.querySelector('[data-sticky-price]');
  const image = bar.querySelector('[data-sticky-image]');
  const fallbackForm = document.getElementById('RSStickyFallbackForm');
  const fallbackVariant = fallbackForm?.querySelector('[data-sticky-variant]');
  let observedButton;
  let observedPrice;
  let scheduled = false;
  const observer = new MutationObserver(() => scheduleUpdate());

  const rendered = (element) => element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';

  const purchaseButton = () => {
    if (!main) return null;
    const selectors = [
      '.bundle-selector__cta[data-add-to-cart]',
      '.rc-product__button',
      '.rs-offers__cta[data-rs-offers-cta]',
      'form[data-type="add-to-cart-form"] button[name="add"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form__submit'
    ];
    for (const selector of selectors) {
      const found = [...main.querySelectorAll(selector)].find(rendered);
      if (found) return found;
    }
    return null;
  };

  const sourcePrice = (source) => {
    const section = source?.closest('[id^="MainProduct-"]') || main;
    return section?.querySelector('[id^="price-"]');
  };

  const observeSource = (source, amount) => {
    if (source === observedButton && amount === observedPrice) return;
    observer.disconnect();
    observedButton = source;
    observedPrice = amount;
    if (source) observer.observe(source, { attributes: true, childList: true, subtree: true, characterData: true });
    if (amount && amount !== source) observer.observe(amount, { childList: true, subtree: true, characterData: true });
  };

  const update = () => {
    const source = purchaseButton();
    const amount = sourcePrice(source);
    observeSource(source, amount);

    const variantField = source?.closest('form')?.querySelector('[name="id"]')
      || main?.querySelector('form[data-type="add-to-cart-form"] [name="id"]:not(:disabled)');
    const urlVariant = new URLSearchParams(location.search).get('variant');
    if (fallbackVariant) fallbackVariant.value = variantField?.value || urlVariant || bar.dataset.defaultVariant;
    const selectedImage = document.querySelector(`[data-sticky-variant-images] [data-variant-id="${fallbackVariant?.value}"]`);
    if (image && selectedImage?.dataset.imageSrc && image.getAttribute('src') !== selectedImage.dataset.imageSrc) image.src = selectedImage.dataset.imageSrc;

    const bundleAmount = source?.querySelector('[data-cta-price], [data-rs-offers-cta-price]');
    if (bundleAmount?.textContent.trim()) {
      price.textContent = bundleAmount.textContent.trim();
    } else if (amount) {
      price.innerHTML = amount.innerHTML;
    }

    const sourceLabel = source?.querySelector('.bundle-selector__cta-text')?.textContent.trim()
      || source?.textContent.replace(/↗/g, '').trim();
    button.textContent = sourceLabel || bar.dataset.addLabel;
    button.disabled = source
      ? source.disabled || source.getAttribute('aria-disabled') === 'true' || source.getAttribute('aria-busy') === 'true'
      : bar.dataset.defaultAvailable !== 'true' || !fallbackVariant?.value;
    if (!source && button.disabled) button.textContent = bar.dataset.soldOutLabel;

    const pastSource = source ? source.getBoundingClientRect().bottom < 0 : window.scrollY > 500;
    const menuOpen = !!document.querySelector('#Details-menu-drawer-container[open]');
    const visible = pastSource && window.scrollY > 120 && !menuOpen;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    bar.inert = !visible;
    document.body.classList.toggle('rs-sticky-product-cart-visible', visible);
  };

  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };

  button.addEventListener('click', () => {
    const source = purchaseButton();
    if (source && !source.disabled) {
      source.click();
    } else if (!source && fallbackVariant?.value) {
      fallbackForm.requestSubmit();
    }
  });

  document.addEventListener('change', scheduleUpdate);
  document.addEventListener('variant:change', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  const menuDrawer = document.getElementById('Details-menu-drawer-container');
  if (menuDrawer) new MutationObserver(scheduleUpdate).observe(menuDrawer, { attributes: true, attributeFilter: ['open'] });
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('popstate', scheduleUpdate);
  window.addEventListener('pageshow', scheduleUpdate);
  update();
})();
